module.exports = __webpack_public_path__ + "images/vector/app/web/src/assets/filetypes/other format icon-4110a675.svg";


//////////////////
// WEBPACK FOOTER
// ./app/web/src/assets/filetypes/other format icon.svg
// module id = ./app/web/src/assets/filetypes/other format icon.svg
// module chunks = 0